{
  "requestListPage": {
    "title": "Запросы на изменение",
    "table": {
      "name": "Имя",
      "creator": "Автор запроса",
      "created_time": "Время создания",
      "description": "Описание",
      "status": "Статус",
      "executor_login": "Выполнил",
      "approved": "Подтвержден",
      "approved_login": "Проверяющий",
      "approvedYes": "Да",
      "approvedNo": "Нет",
      "action": "Действия",
      "approve_user": "Подтверждающий пользователь"
    },
    "tabs": {
      "info": "Информация",
      "changes": "Изменения",
      "status": "Состояние"
    },
    "createRequest": "Создать запрос",
    "editRequest": "Редактировать запрос",
    "withoutChanges": "Нет изменений",
    "changes": "Изменения"
  },
  "requestType": {
    "create_ci": "Создание КЕ",
    "update_ci": "Изменение КЕ",
    "remove_ci": "Удаление КЕ",
    "unknown": "Неожиданное действие"
  },
  "approve": {
    "approve": "Разрешить",
    "revoke": "Отменить"
  },
  "status": {
    "created": "Создан",
    "progress": "В ходе выполнения",
    "complete": "Выполнен"
  },
  "statusInfo": {
    "waiting": "Ожидает выполнения",
    "in_progress": "Выполняется",
    "executed": "Выполнен",
    "failed": "Выполнен с ошибкой",
    "cancelled": "Отменен",
    "rollback_waiting": "Ожидает отката",
    "rollback_in_progress": "Выполняется откат",
    "rollback_executed": "Откат выполнен",
    "rollback_failed": "Ошибка при выполнении отката"
  }
}